/**
 * LocalStorage backed user preferences - for storing state information to help the UI.
 */
const modulestate = () => ({
  /**
   * The job a user currently wants to apply for. We store it so that we can
   * redirect them to login/singup, and then redirect them to it after
   */
  applyForJob: '',
});
const getters = {
  applyForJob: (state) => state.applyForJob,
};
const mutations = {
  updateApplyForJob(state, params) {
    state.applyForJob = params;
  },
};
const actions = {
};

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state: modulestate,
};
